import styled from 'styled-components'

export const StyledTh = styled.th<{ $width?: number }>`
  position: relative;
  ${({ $width }) => ($width != null ? `width: ${$width}px;` : '')}
`

export const ResizeHandle = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 8px;
  cursor: col-resize;
  user-select: none;
  touch-action: none;
  z-index: 1;

  &:hover,
  &.resizing {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 3px;
      bottom: 0;
      width: 2px;
      background: #1677ff;
    }
  }
`
